import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  formControlLabel: {
    width: 'fit-content',
  },
}))

export default styles
